import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type PropType, computed, ref, watch } from "vue";
import item from "../frontend-productlist/product-list/list-item-component/one-per-row/item.vue";
import {
    type ProductListCachedProductViewModel,
    ProductListItem,
    type FillerItem,
} from "../frontend-productlist/product-list/list-item";
import axios from "axios";
import {
    type AddToCartResponse,
    afterAddToCart,
} from "../frontend-productpage/shop/cart-adding";
import { type ProductRegistrationResult } from "../frontend-productlist/product-list/list-item-component/common/product-updater";


const __default__ = {
    name: "product-gallery-item",
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    product: Object as PropType<ProductListCachedProductViewModel>,
    width: {
        type: String,
        required: true,
    },
    forceLazyLoadImage: Boolean,
    filler: {
        type: Boolean,
        default: false,
    },
    loaded: Boolean,
    expectedContentType: String,
    visible: {
        type: Boolean,
        default: true,
    },
    registration: Object as PropType<ProductRegistrationResult>,
    indexOfList: Number,
    //intersection: Number,
},
  emits: ["mounted", "unmount"],
  setup(__props, { emit: __emit }) {

const productItem = ref<FillerItem | ProductListItem>({
    filler: true,
} as FillerItem);

const props = __props;

const actionLoading = ref(false);

async function performAction(event: Event) {
    if (actionLoading.value) return;
    actionLoading.value = true;
    try {
        if (props.product == null) throw new Error("no product");
        if (props.product.actionMode === "add-to-cart") {
            if (props.product.actionHref == null)
                throw new Error("missing actionHref");
            const response = await axios.post<AddToCartResponse>(
                props.product.actionHref,
                undefined,
                {
                    params: {
                        productId: props.product.productId,
                        orderQuantity: 1,
                    },
                }
            );
            if (response.data.success !== true) {
                throw new Error(response.data.errors.join("\n"));
            }

            afterAddToCart(
                props.product.productId,
                response.data.cartItemsCount,
                response.data.firstAdd
            );

            return;
        }
        throw new Error("unknown actionMode: " + props.product.actionMode);
    } finally {
        actionLoading.value = false;
    }
}

watch(
    () => ({ filler: props.filler, product: props.product }),
    (newValue) => {
        if (newValue.filler || newValue.product == null) {
            productItem.value = { filler: true } as FillerItem;
            return;
        }
        const product = newValue.product;
        const listItem = new ProductListItem(
            product,
            false,
            product.trackingInfo,
            0
        );
        // if (props.registration) {
        //     listItem.registration = props.registration;
        // } else if (product.registration) {
        //     listItem.registration = product.registration;
        // }
        productItem.value = listItem;
    },
    {
        immediate: true,
        //deep: true,
    }
);

const itemStyle = computed(() => {
    const style: { [key: string]: string } = {};
    style["width"] = props.width;
    return style;
});

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(item, {
    filler: __props.filler || (!__props.visible && !__props.loaded),
    "force-link": "",
    class: "item product-gallery-item",
    "force-lazy-load-image": __props.forceLazyLoadImage,
    style: _normalizeStyle([itemStyle.value, {"position":"relative"}]),
    ref: "itemCompInst",
    "data-visible": __props.visible.toString(),
    "data-filler": __props.filler.toString(),
    "is-gallery-item": "",
    registration: __props.registration,
    item: productItem.value,
    "onUpdate:item": _cache[0] || (_cache[0] = ($event: any) => ((productItem).value = $event)),
    mobile: "",
    "expected-content-type": __props.expectedContentType,
    "overwrite-action-button-text": 
            __props.product != null && __props.product.actionMode === 'add-to-cart'
                ? __props.product.actionButtonText ?? undefined
                : undefined
        ,
    "overwrite-action-button": 
            __props.product != null && __props.product.actionMode === 'add-to-cart'
        ,
    onActionButtonClick: _cache[1] || (_cache[1] = ($event: any) => (performAction($event))),
    "action-button-loading": actionLoading.value,
    visible: __props.visible,
    "index-of-list": __props.indexOfList,
    onMounted: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('mounted', $event))),
    onUnmount: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('unmount', $event)))
  }, {
    default: _withCtx(() => [
      _createCommentVNode(" <div\r\n            v-if=\"intersection != null\"\r\n            style=\"\r\n                position: absolute;\r\n                width: 100%;\r\n                height: 100%;\r\n                background: rgb(0 128 0 / 50%);\r\n                color: white;\r\n                text-shadow: 0px 0px 10px black;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                font-size: 75px;\r\n            \"\r\n            >{{ Math.round(intersection * 100) }}</div\r\n        > ")
    ], undefined, true),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["filler", "force-lazy-load-image", "style", "data-visible", "data-filler", "registration", "item", "expected-content-type", "overwrite-action-button-text", "overwrite-action-button", "action-button-loading", "visible", "index-of-list"]))
}
}

})